import { render, staticRenderFns } from "./exactList2.vue?vue&type=template&id=2519de3c&scoped=true&"
import script from "./exactList2.vue?vue&type=script&lang=js&"
export * from "./exactList2.vue?vue&type=script&lang=js&"
import style0 from "./exactList2.vue?vue&type=style&index=0&id=2519de3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519de3c",
  null
  
)

export default component.exports